import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';
import axios from 'axios';
import config from '../config';
import Navbar from '../components/Navbar';

const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
  flex: 1;
`;

const Title = styled.h1`
  color: #14464F;
  margin-bottom: 20px;
  font-size: 2em;
`;

const LastUpdated = styled.p`
  color: #666;
  font-size: 0.9em;
  margin-bottom: 30px;
`;

const Content = styled.div`
  white-space: pre-wrap;
  line-height: 1.6;
  color: #333;
  
  h2 {
    color: #14464F;
    margin: 30px 0 15px;
  }
  
  p {
    margin-bottom: 15px;
  }
  
  ul {
    margin-bottom: 15px;
    padding-left: 20px;
  }
  
  li {
    margin-bottom: 5px;
  }
`;

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  color: #14464F;
`;

const ErrorMessage = styled.div`
  color: #dc3545;
  text-align: center;
  padding: 20px;
`;

const LegalDocumentPage = () => {
  const { document } = useParams();
  const { language } = useLanguage();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${config.API_URL}/general/legal/${document}?lang=${language}`);
        setContent(response.data);
        setError(null);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to load document');
      } finally {
        setLoading(false);
      }
    };

    fetchDocument();
  }, [document, language]);

  return (
    <PageWrapper>
      <Navbar hideMiddleSection />
      {loading ? (
        <Container>
          <LoadingSpinner>Loading...</LoadingSpinner>
        </Container>
      ) : error ? (
        <Container>
          <ErrorMessage>{error}</ErrorMessage>
        </Container>
      ) : (
        <Container>
          <Title>{content.title}</Title>
          <LastUpdated>Last updated: {content.lastUpdated}</LastUpdated>
          <Content>{content.content}</Content>
        </Container>
      )}
    </PageWrapper>
  );
};

export default LegalDocumentPage; 